// extracted by mini-css-extract-plugin
module.exports = {"documentIframe":"style_documentIframe__INqa8","iframeModalBtn":"style_iframeModalBtn__OMRc7","termsContainer":"style_termsContainer__mLIev"};